//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DivSpan from '@/components/DivSpan';
import fileUpload from '@/components/file-upload';

export default {
  name: "received-management-view",
  components: { DivSpan,fileUpload},
  data() {
    return {
      dataId:'',
      stockTable: {
        Table:{}
      },
      tabIndex: 1,
      detailTable: {
        data:[],
      },
      gridList: [
        {icon:require('@/assets/icon/supplier/supplier_base_data.png'),label:'基本信息'},
        {icon:require('@/assets/icon/supplier/bidding_detail.png'),label:'整改明细'},
      ],
    }
  },
  methods: {
    changeIndex(i){
      this.tabIndex=i;
    },
    changeShow(data,i) {
      if (data[i].showContent) {
        this.$set(data[i], 'showContent', false);
        return;
      }
      this.$set(data[i], 'showContent', true);
    },
    //获取基本对象
    getBaseDto() {
      this.$loadingShow();
      this.$get('api/stock_table/' + this.dataId).then((data) => {
        if (data) {
          this.stockTable = data;
          this.detailTable.data=this.stockTable.stockTableDtList;
        }
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    // 跳转到 常用页面
    goGeneral() {
      if(this.$store.state.device === 'wap'){
        this.$router.go(-1);
      }else{
        document.location = "http://action:10002/?";
      }
    },
  },
  mounted() {
    this.dataId=this.$route.params.id;
    this.getBaseDto()
  },


}



// WEBPACK FOOTER //
// ./src/page/asn/received-management-view.vue